import type { Translations } from "../types";

const bg: Translations = {
  "meta.title": "Кликове по държави на картата",
  "meta.description":
    "Интерактивна карта на света: безплатни кликове за всяка държава плюс платена подкрепа чрез Stripe, PayPal и Buy Me a Coffee.",

  "app.title": "Кликове по държави на картата",

  "map.intro":
    "Кликнете върху държава на картата, за да ѝ дадете безплатен глас, или ѝ изпратете финансова подкрепа - и двете се броят за общата класация по-долу. Картата отразява само подкрепата в това приложение, а не реалното национално богатство или БВП.",
  "map.verifying": "Проверка …",
  "map.confirmNotRobot": "Преди да можете да добавяте безплатни кликове, потвърдете набързо, че не сте робот:",
  "map.tryAgain": "Опитайте отново",
  "map.registeringClick": "Регистриране на клика …",
  "map.selectedCountry": "Избрана държава: {name}.",
  "map.selectFirstFeedback": "Държавата е избрана. За да добавите безплатен клик, първо потвърдете по-долу, че не сте робот.",
  "map.verificationExpired": "Потвърждението е изтекло - потвърдете отново, че не сте робот.",
  "map.slowDown": "Малко по-бавно - изчакайте момент преди следващия си клик.",
  "map.clickFailed": "Кликът не можа да бъде регистриран. Моля, опитайте отново.",
  "map.clickErrorGeneric": "Грешка при регистрирането на клика.",
  "map.leaderboardHeading": "Класация на държавите",
  "map.emptySelection": "Изберете държава на картата, за да ѝ дадете клик или да я подкрепите.",
  "map.loadingData": "Зареждане на данни …",

  "worldmap.loadError": "Картата не можа да бъде заредена.",
  "worldmap.resetZoom": "Нулиране на мащаба",
  "worldmap.resetButton": "⤾ Нулиране",
  "worldmap.loadingMap": "Зареждане на картата …",
  "worldmap.unknownCountry": "Неизвестна",
  "worldmap.ariaClicks": "{name}: {clicks} кликвания",
  "worldmap.tooltipClicks": "{clicks} кликвания",

  "legend.fewer": "По-малко кликове",
  "legend.more": "Повече кликове",

  "list.empty": "Все още няма кликове. Бъдете първи!",
  "list.ariaLabel": "Класация на държавите по кликове",

  "human.siteKeyMissing": "VITE_TURNSTILE_SITE_KEY не е зададен - вижте README за конфигурация.",
  "human.verificationFailedGeneric": "Потвърждението не бе успешно.",
  "human.networkError":
    "Проверката не бе достъпна (грешка в мрежата) - проверете VITE_SUPABASE_URL, дали verify-human е публикуван, и ALLOWED_ORIGIN; вижте README/NAVODILA.",
  "human.verificationFailedRetry": "Потвърждението не бе успешно, опитайте отново.",

  "provider.stripe": "💳 Карта (Stripe)",
  "provider.paypal": "🅿️ PayPal",
  "provider.buymeacoffee": "☕ Buy Me a Coffee",

  "panel.selectedCountryLabel": "Избрана държава",
  "panel.currentlyRanked": "В момента на място #{rank}",
  "panel.shareCopied": "Копирано ✓",
  "panel.shareShared": "Споделено ✓",
  "panel.shareButton": "🔗 Сподели",

  "panel.tableClicks": "Кликове",
  "panel.tableFree": "Безплатни",
  "panel.tablePaid": "Платени",
  "panel.rowAllTime": "За цялото време",
  "panel.rowThisYear": "Тази година",
  "panel.rowThisWeek": "Тази седмица",
  "panel.rowToday": "Днес",

  "panel.totalCombined": "Общо комбинирано:",
  "panel.totalSupport": "Обща подкрепа:",

  "panel.paymentMethod": "Начин на плащане",
  "panel.noPaymentMethod": "В момента няма наличен начин на плащане.",
  "panel.supportAmount": "Сума на подкрепата (EUR)",
  "panel.amountRange": "Сумата трябва да бъде между {min} и {max}.",
  "panel.quickAmount": "{eur} €",
  "panel.estimatedClicks": "Прогнозни платени кликове:",
  "panel.ratioInfo":
    "Съотношение: {a} = {b} кликове (напр. {c} = {d} кликове). Това е само прогноза преди плащането - крайният брой кликове винаги се изчислява и потвърждава от сървъра въз основа на реално потвърденото плащане.",
  "panel.preparing": "Подготовка …",
  "panel.continueWith": "Продължи с {provider}",
  "panel.choosePaymentMethod": "Изберете начин на плащане",
  "panel.bmcUsernameMissing": "VITE_BMC_USERNAME не е зададен - вижте README за конфигурация.",
  "panel.paypalClientIdMissing": "VITE_PAYPAL_CLIENT_ID не е зададен - вижте README за конфигурация.",

  "panel.paypalAmountInfo": "Сума: {amount} (прогнозно {clicks} кликове). Завършете плащането с бутона на PayPal по-долу.",
  "panel.back": "← Назад",

  "panel.bmcWarningTitle": "⚠️ Преди да продължите към BuyMeCoffee:",
  "panel.bmcWarningBody":
    "Поставете кода по-долу в полето за съобщение/бележка при плащане — само така ще знаем коя държава подкрепяте. Без кода не можем да отнесем плащането към конкретна държава.",
  "panel.copy": "Копирай",
  "panel.copied": "Копирано ✓",
  "panel.suggestedAmount": "Препоръчана сума:",
  "panel.bmcAmountNote":
    "(прогнозно {clicks} кликове). За съжаление BuyMeCoffee не поддържа пренасяне на сумата през линк — въведете/изберете я сами на техния сайт. Реалният брой кликове винаги се изчислява от сумата, която реално изпратите в BuyMeCoffee, а не от тази прогноза.",
  "panel.openBmc": "Отворете BuyMeCoffee и продължете →",
  "panel.waitingProvider": "Изчакване на потвърждение за плащане от доставчика …",
  "panel.waitingConfirmation": "Изчакване на потвърждение за плащане …",
  "panel.timedOut":
    "Проверката отне твърде дълго. Ако сте завършили плащането, картата ще се обнови веднага щом сървърът получи потвърждение - понякога това отнема малко повече време.",
  "panel.checkAgain": "Провери отново",

  "panel.cancelled": "Плащането бе отменено или не бе завършено. Картата не се промени.",
  "panel.tryAgain": "Опитайте отново",

  "panel.confirmed": "✅ Подкрепата е потвърдена!",
  "panel.confirmedBody": "{country} получи {clicks} платени кликове за {amount}.",

  "panel.errorPreparingSupport": "Грешка при подготовката на вашата подкрепа.",
  "panel.errorPreparingPayment": "Грешка при подготовката на плащането.",
  "panel.errorConfirmingPayment": "Грешка при потвърждаването на плащането.",
  "panel.errorPayingPaypal": "Грешка при плащане с PayPal.",

  "share.unranked": "{flag}{country} се нуждае от вашата подкрепа на картата на света!\nПомогнете ѝ да се изкачи в класацията 👇",
  "share.rank1": "{flag}{country} в момента е #1!\nПомогнете ни да останем на върха 👇",
  "share.rankN": "{flag}{country} в момента е на място #{rank}!\nПомогнете ни да стигнем до #1 👇",

  "language.switcherLabel": "Език",
};

export default bg;
